import PropTypes from 'prop-types';
import React, {Component} from 'react';

//lodash
import invoke from 'lodash/invoke';

//components
import {TextDesktop as Text} from 'components/Text';

//styled-components
import {IconAndTextWrapper, ItemButton, ToolbarItem} from './styles';

class ToolbarItemComponent extends Component {
  static defaultProps = {
    isActive: false,
    isDisabled: false
  };

  static propTypes = {
    getToolbarButtonStyle: PropTypes.func,
    iconName: PropTypes.string,
    isActive: PropTypes.bool,
    isDisabled: PropTypes.bool,
    label: PropTypes.string,
    onToggle: PropTypes.func,
    themeIconUrl: PropTypes.string,
    type: PropTypes.string
  };

  handleButtonClick = () => {
    const {isDisabled, iconId} = this.props;

    if (isDisabled) {
      return;
    }

    this.propagateToggle({iconId});
  };

  propagateToggle = ({iconId}) => {
    invoke(this.props, 'onToggle', {type: iconId});
  };

  render() {
    const {isActive, isDisabled, label, themeIconUrl, type, isWarning, iconId} = this.props;

    return (
      <ToolbarItem isActive={isActive} data-cy={type}>
        <ItemButton
          hasContent={!isDisabled}
          onClick={this.handleButtonClick}
          disabled={isDisabled}
          className={isActive ? 'active' : ''}
          style={invoke(this.props, 'getToolbarButtonStyle', iconId)}
          isWarning={isWarning}
        >
          <IconAndTextWrapper>
            <div className={'inline-hint-svg'} dangerouslySetInnerHTML={{__html: themeIconUrl}} />
            {label && (
              <Text tag={'label'} size={'small'}>
                {label}
              </Text>
            )}
          </IconAndTextWrapper>
        </ItemButton>
      </ToolbarItem>
    );
  }
}

export default ToolbarItemComponent;
